/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free DNA/RNA molecular weight calculator. Enter an oligonucleotide sequence to get the molecular weight for single-stranded DNA, double-stranded DNA or single-stranded RNA.`)
};

const es_dnamw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de peso molecular de ADN/ARN. Introduce una secuencia de oligonucleótidos para obtener el peso molecular en ADN monocatenario, ADN bicatenario o ARN monocatenario.`)
};

const de_dnamw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser DNA-/RNA-Molekulargewichtsrechner. Geben Sie eine Oligonukleotidsequenz ein, um das Molekulargewicht für einzelsträngige DNA, doppelsträngige DNA oder einzelsträngige RNA zu erhalten.`)
};

const nl_dnamw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis DNA-/RNA-molecuulgewichtcalculator. Vul een oligonucleotidesequentie in om het molecuulgewicht te krijgen voor enkelstrengs DNA, dubbelstrengs DNA of enkelstrengs RNA.`)
};

const fr_dnamw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur gratuit de masse moléculaire ADN/ARN. Entrez une séquence oligonucléotidique pour obtenir la masse moléculaire pour l'ADN simple brin, l'ADN double brin ou l'ARN simple brin.`)
};

const it_dnamw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito del peso molecolare di DNA/RNA. Inserisci una sequenza oligonucleotidica per ottenere il peso molecolare per DNA a singolo filamento, DNA a doppio filamento o RNA a singolo filamento.`)
};

const pt_br2_dnamw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de peso molecular de DNA/RNA. Informe uma sequência de oligonucleotídeo para obter o peso molecular para DNA de fita simples, DNA de fita dupla ou RNA de fita simples.`)
};

const pt_dnamw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de massa molecular de ADN/ARN. Introduza a sequência de um oligonucleótido para obter a massa molecular para ADN de cadeia simples, ADN de cadeia dupla ou ARN de cadeia simples.`)
};

const ja_dnamw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のDNA/RNA分子量計算ツール。オリゴヌクレオチド配列を入力すると、一本鎖DNA、二本鎖DNA、一本鎖RNAの分子量が得られます。`)
};

const zh_dnamw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费 DNA/RNA 分子量计算器。输入寡核苷酸序列，即可获得单链 DNA、双链 DNA 或单链 RNA 的分子量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_meta_description", locale)
	if (locale === "en") return en_dnamw_meta_description(inputs)
	if (locale === "es") return es_dnamw_meta_description(inputs)
	if (locale === "de") return de_dnamw_meta_description(inputs)
	if (locale === "nl") return nl_dnamw_meta_description(inputs)
	if (locale === "fr") return fr_dnamw_meta_description(inputs)
	if (locale === "it") return it_dnamw_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_meta_description(inputs)
	if (locale === "pt") return pt_dnamw_meta_description(inputs)
	if (locale === "ja") return ja_dnamw_meta_description(inputs)
	return zh_dnamw_meta_description(inputs)
};